/*
* PdfPageBreakContent.js
* Created on 23-11-2017
* @author Olivier for &ranj
* 
* Note: page breaks currently only work if they're inside a PDF section (so adding them to a vertical or horizontal content container has no effect). 
*/

import AbstractPdfContent from "./AbstractPdfContent";

export default class PdfPageBreakContent extends AbstractPdfContent {
    constructor(pageBreakType) {
        super();

        this._type = pageBreakType || PdfPageBreakContent.TYPE_SOFT;
    }

    isHardPageBreak() {
        return this._type === PdfPageBreakContent.TYPE_HARD;
    }

    isSoftPageBreak() {
        return this._type === PdfPageBreakContent.TYPE_SOFT;
    }
}

PdfPageBreakContent.TYPE_SOFT = "TYPE_SOFT"; //soft page break, indicates that a page break can be inserted at this point, but only if the batch of content that comes after it doesn't fit on the current page
PdfPageBreakContent.TYPE_HARD = "TYPE_HARD"; //hard page break, indicates that a page break must be inserted at this point